{
  "welcome": "ようこそ",
  "instructions": "下のボタンをタップしてチェックインを開始してください。",
  "startCheckIn": "チェックインを開始",
  "missingWarehouseTitle": "倉庫情報がありません",
  "missingWarehouseMessage": "リンクが無効です。倉庫 ID が含まれている必要があります",
  "recaptchaAttribution": "このサイトは reCAPTCHA によって保護されており、Google の{privacyPolicy}と{termsOfService}が適用されます。",
  "recaptchaPrivacyPolicy": "プライバシーポリシー",
  "recaptchaTermsOfService": "利用規約",
  "lookupTitle": "参照番号または確認番号を入力して予約を検索してください",
  "referenceNumberLabel": "参照番号または確認番号",
  "referenceNotFoundError": "参照番号または確認番号に一致する有効な予約がありません。",
  "checkIn": "チェックイン",
  "loadTypeLabel": "荷物の種類",
  "directionLabel": "方向",
  "operationLabel": "作業",
  "dockLabel": "ドック",
  "orDivider": "または",
  "noReferenceTitle": "確認番号がありません",
  "noReferenceDescription": "標準のチェックイン手続きで、予約なしで進みます。",
  "checkInWithoutAppointment": "予約なしでチェックイン",
  "readyToCheckInTitle": "チェックインの準備はできましたか？",
  "readyToCheckInDescription": "下をタップして開始してください。次の画面で詳細を入力します。",
  "referenceRequiredHint": "この拠点でチェックインするには参照番号が必要です。",
  "haveAppointment": "予約があります",
  "direction": {
    "inbound": "入荷",
    "outbound": "出荷",
    "inOut": "入荷・出荷",
    "load": "積み込み",
    "unload": "荷降ろし"
  },
  "operation": {
    "live": "ライブ荷役",
    "drop": "ドロップ（切り離し）",
    "other": "その他"
  }
}
